/**
 * @generated SignedSource<<469709ae6c7fe4f9c63e579ad985da61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateCurrentUserInput = {
  displayName?: string | null | undefined;
};
export type UpdateCurrentUserMutation$variables = {
  input: UpdateCurrentUserInput;
};
export type UpdateCurrentUserMutation$data = {
  readonly updateCurrentUser: {
    readonly displayName: string | null | undefined;
    readonly email: string | null | undefined;
    readonly name: string | null | undefined;
    readonly user: {
      readonly displayName: string | null | undefined;
      readonly id: string;
    };
  };
};
export type UpdateCurrentUserMutation = {
  response: UpdateCurrentUserMutation$data;
  variables: UpdateCurrentUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CurrentUser",
    "kind": "LinkedField",
    "name": "updateCurrentUser",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateCurrentUserMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateCurrentUserMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "e9a6e66a6907d6f980c80138c17acc72",
    "id": null,
    "metadata": {},
    "name": "UpdateCurrentUserMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateCurrentUserMutation(\n  $input: UpdateCurrentUserInput!\n) {\n  updateCurrentUser(input: $input) {\n    displayName\n    email\n    name\n    user {\n      id\n      displayName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3b98af3d22421be1fb3168f529c876eb";

export default node;
